import { Icon } from "@evidenceb/athena-common/design-system/Icon";
import { Button } from "@evidenceb/athena-common/design-system/Button";
import React from "react";
import { defineMessages, useIntl } from "react-intl";
import { DismissableMessages } from "../../../interfaces/Session";
import {
    useDismissableMessage,
    useMessageDismiss,
} from "../../MessageDismiss/MessageDismiss";
import "./HelpInfo.scss";

const HelpInfo = () => {
    const intl = useIntl();
    const widgetHasBeenDismissed = useDismissableMessage(
        DismissableMessages.dashboardHelpInfo
    );
    const dismissWidget = useMessageDismiss(
        DismissableMessages.dashboardHelpInfo,
        true
    );
    return (
        <>
            {!widgetHasBeenDismissed && (
                <div className="help-info">
                    <Icon path="users_group_two_rounded" />
                    <div className="help-info__text">
                        <h3>{intl.formatMessage(messages.helpInfoTitle)}</h3>
                        <p>{intl.formatMessage(messages.helpInfoMessage)}</p>
                        <Button
                            onClick={dismissWidget}
                            className="help-info-dismiss"
                            label={intl.formatMessage(messages.helpInfoDismiss)}
                            variant="secondary"
                        />
                    </div>
                </div>
            )}
        </>
    );
};

export default HelpInfo;

const messages = defineMessages({
    helpInfoTitle: {
        id: "classroom-details-help-info-title",
        defaultMessage: "Looks like a student is missing ?",
    },
    helpInfoMessage: {
        id: "classroom-details-help-info-message",
        defaultMessage:
            "Only students who have already logged on to the application are visible in your dashboards.",
    },
    helpInfoDismiss: {
        id: "classroom-details-help-info-dismiss",
        defaultMessage: "Got it.",
    },
});
